export enum RoleTypes {
  ADMIN = 'ADMIN',
  SUBADMIN = 'SUBADMIN',
  USER = 'USER',
  CANDIDATE = 'CANDIDATE',
}
